import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'react-bootstrap-5';
import Select from 'react-select';

import Errors from 'components/form/errors';
import LoadingSpinner from 'components/ui/loading_spinner';
import { remove } from 'components/configurable_enums/api';
import { mapId } from 'helpers/react_select_helpers';

const defaultState = {
  errors: [],
  saving: false,
  selectedValue: null
};

export default class ConfigurableEnumDeleteModal extends React.Component {
  static propTypes = {
    basePath: PropTypes.string.isRequired,
    enumValue: PropTypes.shape({
      id: PropTypes.number.isRequired,
      label: PropTypes.string
    }).isRequired,
    enumValues: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired
    })).isRequired,
    formLabel: PropTypes.string,
    show: PropTypes.bool,

    onCancel: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired
  }

  state = defaultState;

  componentDidUpdate(previousProps) {
    if (this.props.show && !previousProps.show) {
      this.setState(defaultState);
    }
  }

  handleChange = (selectedValue) => {
    this.setState({ selectedValue });
  }

  handleDelete = () => {
    const { basePath, enumValue, onDelete } = this.props;
    const { selectedValue } = this.state;
    this.setState({ errors: [], saving: true });

    remove(basePath, enumValue.id, selectedValue.id)
      .then(onDelete)
      .catch(errors => this.setState({ errors, saving: false }));
  }

  render() {
    const { onCancel, show } = this.props;
    const { errors, saving, selectedValue } = this.state;

    return (
      <Modal
        className="form-modal visible-overflow"
        show={show}
        onHide={onCancel}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete {this.props.formLabel}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Errors className="mb-3" errors={errors}/>
          {this.renderForm()}
        </Modal.Body>

        <Modal.Footer>
          <Button name="cancel" variant="cancel" onClick={onCancel}>
            Cancel
          </Button>

          <Button
            disabled={selectedValue == null || saving}
            name="update-and-delete"
            onClick={this.handleDelete}
            variant="primary"
          >
            Update and Delete
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  renderForm() {
    const { formLabel, enumValue, enumValues } = this.props;
    return (
      <div id="delete-form">
        {this.state.saving && <LoadingSpinner skipTopBuffer={true} />}
        <div className="mb-3">
          Update all records with a {formLabel} of '{enumValue.label}' to:
        </div>
        <label className="fw-semibold">{formLabel}</label>
        <Select
          getOptionValue={mapId}
          id={`${formLabel.toLowerCase()}-ref-update-selector`}
          options={enumValues.filter(val => val.id !== enumValue.id)}
          value={this.state.selectedValue}
          onChange={this.handleChange}
        />
      </div>
    );
  }
}
